//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

import {
  createStripeInstance,
  inputStyles,
  handleCardInputChange,
} from '~/components/checkout/utils/stripeElements';

export default {
  name: 'CreditCardCapture',
  props: {
    card: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cardElement: null,
    };
  },
  mounted() {
    const elements = createStripeInstance().elements();
    this.cardElement = elements.create('card', { style: inputStyles });
    const emitCardChanged = { emitComplete: () => this.$emit('update:card', this.cardElement) };
    this.cardElement.addEventListener('change', handleCardInputChange.bind(emitCardChanged));
    this.cardElement.mount(`#${this.id}`);
  },
  computed: {
    ...mapGetters(['isGQOrder']),
  },
  unmounted() {
    this.cardElement.unmount();
  },
};
